var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"abs border-radius-h hand hot",style:({width:_vm.size+'px',height:_vm.size+'px',top:_vm.top+'px',left:_vm.left+'px',right:_vm.right+'px',bottom:_vm.bottom+'px'})})
}
var staticRenderFns = []

export { render, staticRenderFns }